<template>
  <section class="flow">
    <div class="container">
      <a-typography-title :level="1">
        <span>全流程成本管理</span>
        <template v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)">，</template>
        <br v-else />
        <span>保障云资源利用率最大化</span>
      </a-typography-title>
      <a-tabs v-model:activeKey="tab.active"
              :tabBarGutter="$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)?150:20" centered>
        <a-tab-pane v-for="(item,index) in tab.list"
                    :key="index+1" :tab="item.title">
          <a-row :class="{tab_show:tab.show===index+1}">
            <a-col :xs="24" :lg="10"
                   :order="$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)?1:2">
              <div class="item" :class="`i_${index+1}`">
                <a-typography-title v-if="item.title" :level="5">
                  {{ item.title }}
                </a-typography-title>
                <a-typography-title v-if="item.sub" :level="5">
                  {{ item.sub }}
                </a-typography-title>
                <a-typography-paragraph v-if="item.text">
                  {{ item.text }}
                </a-typography-paragraph>
                <!-- <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
                  <a-button type="link" class="button_1"
                            @click="$RQ.GoGSS()">
                    免费试用
                  </a-button>
                </a-space> -->
              </div>
            </a-col>
            <a-col :xs="24" :lg="{offset:2,span:12}"
                   :order="$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)?2:1">
              <div class="media" :class="`m_${index+1}`" />
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'plan_flow',
  data(): DataInterface {
    return {
      tab: {
        active: 1,
        show: 1,
        list: [
          {
            title: '成本洞察',
            sub: '多云成本可视化，迅速定位优化点',
            text: '星汉未来通过多云环境成本数据统一全景展示，帮助您深入全面洞察云上成本，为成本优化提供有力依据，并提供日度、月度、季度、年度成本预测，帮助您合理分配资源。'
          },
          {
            title: '算力治理',
            sub: '多维度体系化降本，保障稳定性',
            text: '星汉未来提供整套算力治理方案，通过多种先进技术手段，从多个维度提高资源利用率、提升资源调度效率，在保障业务高可用性的前提下，实现成本的大幅优化！'
          },
          {
            title: '持续运营',
            sub: '成本运营流程化，降本效果可持续',
            text: '覆盖成本管理全流程，从业务规划、成本预算、到资源申请、业务上线、例行监测，持续评估业务成本现状与优化目标之间的差距，并采取运营措施，保障成本优化效果的持续性。'
          }
        ]
      }
    }
  },
  watch: {
    'tab.active': {
      async handler(newData: any, oldDate: any): Promise<any> {
        await $FN.WaitTime(50);
        this.tab.show = newData;
      }
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/planCost/';

.flow {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-tabs {
  overflow: initial;
  margin: 15px 0 0;
  
  &:deep(.ant-tabs-nav) {
    &::before {
      border-bottom: 1px solid #D8D8D8;
    }
    
    .ant-tabs-nav-list {
      position: relative;
      
      &::before {
        content: '';
        display: block;
        .position(absolute, auto, 0, 1px, 50%);
        z-index: 0;
        width: 200%;
        .transform(translateX(-50%) scale(0.5));
      }
      
      .ant-tabs-ink-bar {
        height: 3px;
      }
    }
    
    .ant-tabs-tab {
      @wh: 60px;
      padding: 5px 0;
      .font(center, @text_big, @color_12, @text_big, true);
      
      .loop(@i) when (@i<=3) {
        &:nth-child(@{i}) {
          &::before {
            background-position-x: -(-1+@i)*@wh;
          }
        }
        .loop(@i+1);
      }
      .loop(1);
      
      &.ant-tabs-tab-active {
        .ant-tabs-tab-btn {
          color: @color_6;
        }
      }
      
      &::before {
        content: '';
        display: inline-block;
        width: @wh;
        height: @wh;
        margin-right: 10px;
        .bg('@{image}flow_icon.png', @wh*3, @wh);
      }
    }
    
    .ant-tabs-ink-bar {
      background-color: @color_6;
    }
  }
  
  &:deep(.ant-tabs-content) {
    .ant-tabs-tabpane {
      .tab_show {
        .media,
        .item {
          opacity: 1;
          .transform(translate(0, 0));
        }
      }
      
      .media {
        .transform(translate(100px, 0));
      }
      
      .item {
        .transform(translate(-100px, 0));
      }
      
      .media,
      .item {
        @aTime: 1s;
        @style: transform @aTime, opacity @aTime;
        opacity: 0;
        .transition(@style);
      }
    }
  }
}

.ant-row {
  .ant-col {
    position: relative;
    
    &:nth-child(1) {
      z-index: 1;
    }
    
    &:nth-child(2) {
      z-index: 0;
    }
  }
}

.media {
  position: relative;
  height: 400px;
  pointer-events: none;
  
  &.m_1 {
    &::before {
      .position(absolute, calc(~'50% + 10px'), auto, auto, calc(~'50% + 10px'));
      .bg('@{image}flow_image_1_bg.png', 641px, 423px, true);
    }
    
    &::after {
      .position(absolute, 50%, auto, auto, 50%);
      .bg('@{image}flow_image_1.png', 579px, 360px, true);
    }
  }
  
  &.m_2 {
    &::before {
      .position(absolute, calc(~'50% + 180px'), auto, auto, 50%);
      .bg('@{image}flow_image_2_bg.png', 595px, 80px, true);
    }
    
    &::after {
      .position(absolute, calc(~'50% - 20px'), auto, auto, 50%);
      .bg('@{image}flow_image_2.png', 588px, 356px, true);
    }
  }
  
  &.m_3 {
    &::before {
      .position(absolute, calc(~'50% + 120px'), auto, auto, 50%);
      .bg('@{image}flow_image_3_bg.png', 616px, 188px, true);
    }
    
    &::after {
      .position(absolute, calc(~'50% - 20px'), auto, auto, 50%);
      .bg('@{image}flow_image_3.png', 513px, 351px, true);
    }
  }
  
  &::before,
  &::after {
    content: '';
    display: block;
  }
  
  &::before {
    .transform(translate(calc(~'-50% + var(--mouse-x,0px) * -0.02'), calc(~'-50% + var(--mouse-y,0px) * -0.02')));
  }
  
  &::after {
    .transform(translate(calc(~'-50% + var(--mouse-x,0px) * -0.01'), calc(~'-50% + var(--mouse-y,0px) * -0.01')));
  }
}

.item {
  .position();
  max-width: 450px;
  height: 220px;
  margin: auto 0;
  
  h5.ant-typography {
    margin: 0;
    .font(justify, @title_sub, @color_12, @title_sub, true);
    
    &:nth-child(2) {
      margin: @margin_mo 0 0;
      .font(justify, @text_big, @color_12, @text_big, true);
    }
  }
  
  div.ant-typography {
    position: relative;
    margin: @margin_mo 0 0;
    .font(justify, @text+@line, @color_13, @text);
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}

@media screen and (max-width: -1px+@grid_xl) {
  .ant-tabs {
    &:deep(.ant-tabs-content) {
      .ant-tabs-tabpane {
        .tab_show {
          .media {
            .transform(translate(0, 0) scale(0.75));
          }
        }
        
        .media {
          .transform(translate(100px, 0) scale(0.75));
        }
      }
    }
  }
}

@media screen and (max-width: -1px+@grid_lg) {
  .ant-tabs {
    &::before {
      top: 300px;
    }
    
    &:deep(.ant-tabs-content) {
      .ant-tabs-tabpane {
        .tab_show {
          .media {
            .transform(translate(0, 0) scale(0.5));
          }
        }
        
        .media {
          @aTime: 1s;
          @style: transform @aTime, opacity @aTime;
          .transition(@style);
          .transform(translate(0, 50px) scale(0.5));
        }
        
        .item {
          @aTime: 1s;
          @dTime: 0.2s;
          @style: transform @aTime @dTime, opacity @aTime @dTime;
          .transition(@style);
          .transform(translate(0, 50px));
        }
      }
    }
  }
  
  .media {
    height: 200px;
  }
  
  .item {
    position: relative;
    height: auto;
    margin: @margin auto 0;
    text-align: center;
    
    .ant-space {
      margin: @margin_mo auto 0;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .flow {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-tabs {
    margin: @margin_mo 0 0;
    
    &:deep(.ant-tabs-nav) {
      .ant-tabs-tab {
        @wh: 20px;
        .font(center, @font_7+@line, @color_12, @font_7, true);
        
        .loop(@i) when (@i<=3) {
          &:nth-child(@{i}) {
            &::before {
              background-position-x: -(-1+@i)*@wh;
            }
          }
          .loop(@i+1);
        }
        .loop(1);
        
        &::before {
          width: @wh;
          height: @wh;
          margin-right: 5px;
          .bg('@{image}flow_icon.png', @wh*3, @wh);
        }
      }
    }
  }
  
  .item {
    max-width: 350px;
    
    h5.ant-typography {
      .font(justify, @title_sub_mo+@line_mo, @color_12, @title_sub_mo, true);
      
      &:nth-child(1) {
        display: none;
      }
      
      &:nth-child(2) {
        margin: 0;
        .font(justify, @text_big_mo+@line_mo, @color_12, @text_big_mo, true);
      }
    }
    
    div.ant-typography {
      .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
    }
  }
}
</style>